module.exports = __webpack_public_path__ + "img/the-netherlands-ischemic-heart-disease-male.c52d98d1.png";